<template>
  <div class="report-template">
    <div class="report-header">
      <h1 class="report-title public-page-title textMainColor">{{ $t('Rewards History') }}</h1>
    </div>
    <div class="report-content">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <div v-else-if="!isLoading && isDataEmpty" class="holder-not-logged-text report-empty-wrap">
        <div class="report-empty-list">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
            <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
          </svg>
          <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
        </div>
      </div>
      <table v-else-if="rewardsDistributionHistory.length" class="history-rewards-table">
        <thead class="holder-table">
        <tr class="table-head">
          <th class="number">
            <p>
              <span class="textSecondaryColor">{{ $t('Distribution No.') }}</span>
            </p>
          </th>
          <th class="date">
            <p>
              <span class="textSecondaryColor">{{ $t('Distribution Date') }}</span>
            </p>
          </th>
          <th class="size">
            <p>
              <span class="textSecondaryColor">{{ $t('Total Pool Size') }}</span>
            </p>
          </th>
          <th class="program">
            <p>
              <span class="textSecondaryColor">{{ $t('Referral Program') }}</span>
            </p>
          </th>
          <th class="rewards">
            <p>
              <span class="textSecondaryColor">{{ $t('Robinhood Rewards') }}</span>
            </p>
          </th>
          <th class="user">
            <p>
              <span class="textSecondaryColor">{{ $t('You Got') }}</span>
            </p>
          </th>
        </tr>
        </thead>
        <tbody class="open-orders-table-main">
        <RoundsOfRewardsItems
            v-for="(distributionHistoryItem, index) in rewardsDistributionHistory"
            :key="index"
            :distributionHistoryItem="distributionHistoryItem"
            :token="token"
        />
        </tbody>
      </table>
      <div class="table-footer" v-if="rewardsDistributionHistory.length">
        <div
            class="report-download"
        >
        </div>
        <b-pagination-nav
            v-if="rewardsDistributionHistory.length && count !== 1"
            v-model="page"
            :link-gen="linkGen"
            :number-of-pages="count"
            :per-page="pageSize"
            :total-rows="count"
            class="pagination"
            first-number
            last-number
            next-text="»"
            prev-text="«"
            use-router
        />
      </div>
    </div>
  </div>
</template>
<script>
import LottieAnimation from "lottie-web-vue";
import RoundsOfRewardsItems from "@/components/rewards/RewardsHistory/RoundsOfRewardsItems.vue";
import { mapActions } from 'vuex';

export default {
  name: 'RewardsHistory',
  props: {
    token: {},
  },
  data() {
    return {
      rewardsDistributionHistory: [],
      currentRewardsUserHistory: [],
      walletAddress: null,
      counters: {},
      page: 1,
      count: 1,
      pageSize: 20,
      isLoading: null,
      isDataEmpty: false,
    };
  },
  components: {
    LottieAnimation,
    RoundsOfRewardsItems,
  },
  watch: {
    token(val) {
      if(val) {
        this.getRewardsDistributionHistoryAction();
      }
      if(val === null) {
        this.currentReferralUser = null
      }
    },
    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if(newVal) {
          this.page = newVal;
          this.changeSelectFilter();
        } else {
          this.page = 1;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getRewardsDistributionHistory: 'rewards/getRewardsDistributionHistory',
      getRewardsUserDistributionHistory: 'rewards/getRewardsUserDistributionHistory',
    }),
    linkGen(pageNum) {
      return {
        path: '/rewards/referral-program',
        query: { page: pageNum },
      };
    },
    getRequestParams(formData) {
      const params = {};

      for (const data in formData) {
        if(formData[data]) {
          params[data] = formData[data];
        }
      }

      return params;
    },
    getRewardsDistributionHistoryAction() {
      this.isLoading = true;
      this.getRewardsDistributionHistory().then(res => {
        let historyArr = res.data.reverse();
        const historyArray = historyArr;
        if(this.token) {
          this.getRewardsUserDistributionHistory().then(res => {

            this.currentRewardsUserHistory = res.data
            const historyUserArray = this.currentRewardsUserHistory;

            if(historyArray.length) {
              historyArray.forEach((history, i) => {
                if(historyUserArray.length) {
                  historyUserArray.forEach(item => {
                    if(history.roundNumber === item.roundNumber) {
                      history.totalProfit = item.totalProfit;
                    }
                  })
                }
              })
            }
            this.rewardsDistributionHistory = historyArray

            if(!this.rewardsDistributionHistory.length) {
              this.isDataEmpty = true;
            }
          });
        }else {
          this.rewardsDistributionHistory = historyArray

          if(!this.rewardsDistributionHistory.length) {
            this.isDataEmpty = true;
          }
        }
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.getRewardsDistributionHistoryAction();
  },
};
</script>
<style lang="scss">
.table-body td {
  padding: 6px 0;
}

.history-rewards-table {
  width: 100%;

  p {
    padding-left: 0px;
    text-align: right;
  }

  .table-head {
    th {
      width: auto;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .number {
      text-align: left;
      padding-left: 20px;
    }

    .user {
      padding-right: 20px;
    }

    .number p {
      text-align: left;
    }

    p {
      text-align: right;
    }
  }
}
</style>
